import { render, staticRenderFns } from "./index.vue?vue&type=template&id=30259286&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=30259286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30259286",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\project_nav_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30259286')) {
      api.createRecord('30259286', component.options)
    } else {
      api.reload('30259286', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=30259286&scoped=true&", function () {
      api.rerender('30259286', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customBox/index.vue"
export default component.exports